import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserSessionService } from 'src/app/user-session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(public jwtHelper: JwtHelperService, private userSessionService: UserSessionService) { }

  public isAuthenticated(): boolean {
    const token = this.userSessionService.getUser()?.token;
    if (!token) return false;

    const raw = token.replace(/^CBCL\s+/i, '').trim();

    // si ce n’est pas un JWT (pas 3 segments), on refuse proprement
    if (raw.split('.').length !== 3) return false;

    return !this.jwtHelper.isTokenExpired(raw);
  }

}
